import { Badge, Center, Group, Stack, Text, ThemeIcon } from '@mantine/core'
import { IconPhoto } from '@tabler/icons-react'
import { FormattedMessage } from 'react-intl'
import { formatSize } from '@/utils/file'
import { AcceptedFileTypes } from './UploadDropzone'

type DropzoneInstructionsProps = {
  maxFileSize: number // in bytes
  maxFilesPerUpload?: number
  acceptedFileTypes?: AcceptedFileTypes
}

export const DropzoneInstructions = ({
  maxFileSize,
  maxFilesPerUpload,
  acceptedFileTypes
}: DropzoneInstructionsProps) => {
  return (
    <Center mih={350} p="lg">
      <Group gap={60} align="start" wrap="nowrap">
        <ThemeIcon size={100} radius="md" variant="light">
          <IconPhoto style={{ width: '80%', height: '80%' }} />
        </ThemeIcon>

        <Stack gap="xl">
          <Text fw={600} size="md">
            <FormattedMessage id="datasets.upload.dropYourFiles" />
          </Text>

          <Stack gap="xs">
            <Badge variant="light" size="lg">
              <FormattedMessage
                id="datasets.upload.maxFileSize"
                values={{
                  fileSize: formatSize(maxFileSize, 'b', true)
                }}
              />
            </Badge>

            {acceptedFileTypes && (
              <Badge variant="light" size="lg">
                <FormattedMessage
                  id="datasets.upload.supportedFileTypes"
                  values={{
                    fileTypes: acceptedFileTypes.join(', ')
                  }}
                />
              </Badge>
            )}

            {maxFilesPerUpload && (
              <Badge variant="light" size="lg">
                <FormattedMessage
                  id="datasets.upload.maxFilesPerUpload"
                  values={{
                    count: maxFilesPerUpload
                  }}
                />
              </Badge>
            )}
          </Stack>
        </Stack>
      </Group>
    </Center>
  )
}
